// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i7UTD","content":"styles_content__N3JI_","tableWrap":"styles_tableWrap__1PKrF"};